import SubMeterForm from './SubMeterForm';

const AddSubMeter = () => {
    return <SubMeterForm isUpdate={false} />;
};

export default AddSubMeter;
